import { SxProps, Theme, Tooltip, Typography } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";

type FAQTruncatedTextProps = {
  text: string;
  sx?: SxProps<Theme>;
  className?: string;
  "aria-hidden"?: boolean;
};

export const FAQTruncatedText = ({
  text,
  sx,
  className,
  "aria-hidden": ariaHidden,
}: FAQTruncatedTextProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = ref.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [text, checkOverflow]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new ResizeObserver(() => checkOverflow());
    observer.observe(el);
    return () => observer.disconnect();
  }, [checkOverflow]);

  return (
    <Tooltip
      title={text}
      placement="top"
      disableHoverListener={!isOverflowed}
      describeChild>
      <Typography
        ref={ref}
        component="span"
        className={className}
        aria-hidden={ariaHidden}
        sx={sx}>
        {text}
      </Typography>
    </Tooltip>
  );
};
